<template>
  <!-- Download list -->
  <div class="modalSelect">
    <el-radio-group v-model="radioUploading" class="radioOffset">
      <el-radio-button label="Drag and drop"></el-radio-button>
      <el-radio-button label="Upload by url"></el-radio-button>
    </el-radio-group>

    <div class="gifs-panels">
      <div v-show="radioUploading === 'Upload by url'">
        <el-input
          v-model="UploadUrl"
          class="inputUploadUrl"
          placeholder="Please enter the url. Example: http//site.com/video.mp4"
          clearable
        >
        </el-input>
        <div>
          <el-button
            v-if="radioUploading === 'Upload by url'"
            slot="tip"
            :disabled="isDisabled"
            type="success"
            class="el-upload__tip"
            @click="submitUpload"
            >Upload
            <!-- {{ uploadPercentage }} -->
          </el-button>
        </div>
        <!-- <div class="uploadLinkUrl"> -->
        <!-- Uploaded by user in clips -->
        <!-- {{ uploadedByUserUrl.join(" ") }} -->
        <!-- </div> -->
      </div>

      <div v-show="radioUploading === 'Drag and drop'">
        <el-upload
          ref="upload"
          class="upload-demo"
          drag
          :show-file-list="showList"
          :accept="checkUploadFormat"
          :action="'undefined'"
          :auto-upload="false"
          :on-change="handleChange"
          multiple
        >
          <a class="el-upload-list__item-name"
            ><i class="el-icon-upload"></i
          ></a>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
        </el-upload>
        <div>
          <el-button
            v-if="radioUploading === 'Drag and drop'"
            slot="tip"
            :disabled="isDisabled"
            type="success"
            class="el-upload__tip"
            @click="submitUpload"
            >Upload
            <!-- {{ uploadPercentage }} -->
          </el-button>
        </div>
        <!-- <div class="uploadDragEndDrop"> -->
        <!-- Uploaded by user in clips -->
        <!-- {{ uploadedByUser.join(" ") }} -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getAPI, token } from "@/api/params.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { uploadFile } from "@/api/fileUpload.js";

export default {
  name: "ModalVideoUpload",
  props: {

  },
  data() {
    return {
      radioUploading: "Drag and drop",
      itemsFiles: [],
      uploadingProcess: 0,
      uploadedByUser: [],
      uploadingId: [],
      UploadUrl: "",
      showList: false,
      isDisabled: true
    };
  },
  watch: {
    itemsFiles() {
      if (this.itemsFiles.length == 0) {
        this.showList = false;
        this.isDisabled = true;
      } else {
        this.showList = true;
        this.isDisabled = false;
      }
    },
    UploadUrl() {
      if (this.UploadUrl == "") {
        this.showList = false;
        this.isDisabled = true;
      } else {
        this.showList = true;
        this.isDisabled = false;
      }
    },
    uploadingProcess() {
      this.$emit("uploadingProcessing", this.uploadingProcess);
    },
    uploadingId(id) {
      this.$emit("selectIdUploading", id);
    }
  },
  computed: {
    ...mapGetters(["channelType"]),
    ...mapState({
      /** stream info */
      app: state => state.services.app,
      stream: state => state.services.stream,
      mangomoloChannelId: state => state.services.mangomoloChannelId,
      /** storage */
      storagePath: state => state.services.thumbs,
      httpStoragePath: state => state.services.httpStorage,
      /** modal */
      modals: state => state.modals.clipper.MODALS
    }),
    checkUploadFormat() {
      return this.channelType === "audio"
        ? ".mp3"
        : ".mp4,.avi,.mov,.flv,.vob,";
    }
  },
  methods: {
    // @vuese
    // Show success notification
    // @arg title - main subject <br>
    // @arg message - detalaized description
    showSuccess(title, message) {
      this.$notify({
        group: "foo",
        position: "bottom right",
        type: "success",
        title: title,
        text: message
      });
    },
    // @vuese
    // Show error notification
    // @arg title - main subject <br>
    // @arg message - detalaized description
    showError(title, message) {
      this.$notify({
        group: "foo",
        position: "bottom right",
        type: "error",
        title: title,
        text: message
      });
    },
    submitUpload() {
      if (this.radioUploading === "Drag and drop") {
        const linkAudioUpload = `${getAPI()}/audio/uploader/get_uploading_link?token=${token}&app=ndvr&${
          this.stream !== undefined ? `&stream=${this.stream}` : ""
        }`;
        const linkVideoUpload = `${getAPI()}/video/uploader/get_uploading_link?token=${token}&app=ndvr&${
          this.stream !== undefined ? `&stream=${this.stream}` : ""
        }`;
        fetch(
          `${this.channelType === "audio" ? linkAudioUpload : linkVideoUpload}`,
          {
            method: "POST",
            body: JSON.stringify({
              items: this.itemsFiles.map(file => {
                return { fileName: file.name };
              })
            }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          }
        )
          .then(response => response.json())
          .then(commits => {
            if (commits.success === true) {
              this.$refs.upload.clearFiles();
            } else {
              ("error");
            }
            const uploadingLinkUrl = commits.data.uploadingUrl;
            this.uploadingId =
              this.channelType === "audio"
                ? commits.data.item.map(e => e.audioId)
                : commits.data.item.map(e => e.videoId);
            const files = this.itemsFiles.slice();
            this.itemsFiles = [];

            function postData(url, data, onProgress) {
              return new Promise(function(resolve, reject) {
                const request = new XMLHttpRequest();
                request.open("POST", url);
                request.upload.onprogress = function(e) {
                  const percent_completed = (e.loaded / e.total) * 100;
                  onProgress(percent_completed);
                };
                request.onerror = reject;
                request.addEventListener("readystatechange", function(e) {
                  console.warn(request.readyState);
                  if (request.status < 300) {
                    resolve({
                      status: request.status,
                      response: request.response
                    });
                  } else {
                    reject({
                      status: request.status,
                      response: request.response
                    });
                  }
                });
                request.send(data);
              });
            }

            Promise.all(
              commits.data.item.map((item, index) => {
                const formdata = new FormData();
                formdata.append("file", files[index].raw, item.fileName);
                formdata.append("token", item.uploadingToken);
                formdata.append("callback_url", item.callbackUrl);
                formdata.append("file_size", files[index].size);
                formdata.append("isUploadedByUser", item.isUploadedByUser);
                formdata.append("isMultistepSource", item.isMultistepSource);

                const requestOptions = {
                  url: uploadingLinkUrl,
                  method: "post",
                  data: formdata,
                  onUploadProgress: function(progressEvent) {
                    this.uploadPercentage = parseInt(
                      Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                      )
                    );
                  }.bind(this)
                };
                console.log(
                  "onUploadProgress",
                  requestOptions.onUploadProgress
                );
                return postData(uploadingLinkUrl, formdata, e => {
                  this.uploadingProcess = Number(e.toFixed());
                });
              })
            );
            files.forEach(item => this.uploadedByUser.push(item.name));
            // this.uploadedByUser.push(files[0].name);
            this.showSuccess("File uploaded in clips");
          });
        this.$emit("closeModal");
      } else {
        const checkUrl = /^(https?|HTTP?)\:\/\/\S+\/\S*[^.]\S*$/.test(
          this.UploadUrl
        );
        if (checkUrl) {
          uploadFile(
            this.stream,
            this.UploadUrl,
            () => {
              this.$refs.upload.clearFiles();
              this.UploadUrl = "";
            },
            uploadingId => {
              this.uploadingId = uploadingId;
            }
          ).then(() => {
            this.$emit("closeModal");
            this.showSuccess("File uploaded in clips");
          });
        } else {
          this.showError("Invalid url");
        }
      }
    },
    handleChange(file) {
      this.itemsFiles.push(file);
    }
  }
};
</script>

<style>
.el-upload {
  margin: 20px auto;
}
</style>

<style scoped>
.radioOffset {
  width: 100%;
  text-align: center;
  /* margin-bottom: 10px;
  margin-left: 198px; */
}

.inputUploadUrl {
  border: 1px solid white;
  border-radius: 4px;
}

.el-upload__tip {
  background: #67c23a;
  display: flex;
  margin: 25px auto;
  color: #ffffff;
  border-radius: 4px;
  height: 40px;
  font-size: 15px;
}
.el-upload__tip:hover {
  background: #5fb04a;
}

.uploadLinkUrl {
  margin-bottom: 20px;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-upload-list__item-name {
  color: #ffffff;
}

.el-upload-dragger .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 70px 0 16px;
  padding: 0px 140px;
  line-height: 50px;
}
.el-upload-dragger {
  width: 95%;
}
.el-upload-dragger {
  /* margin: 0 auto; */
}
/* .el-upload .el-upload--text{
  margin: 0 auto !important;
} */

.el-upload-list__item .el-icon-upload-success {
  display: none;
}

.el-upload-dragger .el-upload__text {
  color: black;
}

.el-upload-dragger .el-upload__text em {
  color: #409eff;
  font-style: normal;
}

.uploadDragEndDrop {
  margin-bottom: 20px;
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .radioOffset[data-v-6ca972fe] {
    /* margin-bottom: 10px;
    margin-left: 119px; */
    width: 100%;
    text-align: center;
  }

  .el-upload__tip {
    background: #67c23a;
    display: flex;
    margin: 25px auto;
    color: #ffffff;
    border-radius: 4px;
    height: 40px;
    font-size: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .radioOffset[data-v-6ca972fe] {
    width: 100%;
    text-align: center;
    /* margin-bottom: 10px;
    margin-left: 223px; */
  }

  .el-upload__tip {
    background: #67c23a;
    display: flex;
    margin: 25px auto;
    color: #ffffff;
    border-radius: 4px;
    height: 40px;
    font-size: 15px;
  }
}
@media only screen and (min-width: 1224px) {
  .radioOffset[data-v-6ca972fe] {
    width: 100%;
    text-align: center;
    /* margin-bottom: 10px; */
    /* margin-left: 310px; */
    /* margin-left: 198px; */
  }

  .el-upload__tip {
    background: #67c23a;
    display: flex;
    margin: 25px auto;
    color: #ffffff;
    border-radius: 4px;
    height: 40px;
    font-size: 15px;
  }
}
@media only screen and (min-width: 1224px) {
  .radioOffset[data-v-6ca972fe] {
    width: 100%;
    text-align: center;
    /* margin-bottom: 10px; */
    /* margin-left: 310px; */
    /* margin-left: 198px; */
  }

  .el-upload__tip {
    background: #67c23a;
    display: flex;
    margin: 25px auto;
    color: #ffffff;
    border-radius: 4px;
    height: 40px;
    font-size: 15px;
  }
}
@media only screen and (min-width: 1424px) {
  .radioOffset[data-v-6ca972fe] {
    width: 100%;
    text-align: center;
    /* margin-bottom: 10px; */
    /* margin-left: 310px; */
    /* margin-left: 218px; */
  }

  .el-upload__tip {
    background: #67c23a;
    display: flex;
    margin: 25px auto;
    color: #ffffff;
    border-radius: 4px;
    height: 40px;
    font-size: 15px;
  }
}
@media only screen and (min-width: 1624px) {
  .radioOffset[data-v-6ca972fe] {
    width: 100%;
    text-align: center;
    /* margin-bottom: 10px; */
    /* margin-left: 310px; */
  }

  .el-upload__tip {
    background: #67c23a;
    display: flex;
    margin: 25px auto;
    color: #ffffff;
    border-radius: 4px;
    height: 40px;
    font-size: 15px;
  }
}
</style>
